import { useRouter } from 'next/router';
import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import { RootState } from '../../store/store';
import {
  ENROLLMENT_EXPIRY_TIME_FALLBACK,
  getCookie,
  getCookieExpiryTime,
  getEnrollmentId,
} from '../../lib/utils/enrollmentUtil';
import * as CdpService from '../../services/CdpService';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { post } from '../../lib/utils/axiosFetcher';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { setCookie, deleteCookie } from 'cookies-next';
import { JOURNEY_STATUS } from '../../../src/constants';

const useUpdateCurrentJourney = (route: any): any => {
  const potentialParticipantDetailsFromStore = useSelector(
    (state: RootState) => state.potentialParticipantDetails
  );
  const { sitecoreContext } = useSitecoreContext();

  const siteSettings: any = sitecoreContext?.siteSettings;
  //const sourceApp = siteSettings?.source?.fields?.name?.value;
  const isJourneyStatusUpdated = useRef<boolean>(false);

  const cdpState = useSelector((state: RootState) => state.cdpData);
  const isAuthenticated: boolean = useSelector(
    (state: RootState) => state.authentication.isAuthenticated
  );
  const updatePatientOutcomeDetails = async (isSuccessPage: boolean) => {
    if (
      potentialParticipantDetailsFromStore?.potentialId ||
      (sitecoreContext as any)?.CDP?.potentialId
    ) {
      const { potentialId } = potentialParticipantDetailsFromStore;
      const { patientReferralStatus } = cdpState;
      const payload: any = {
        potentialId: potentialId || (sitecoreContext as any)?.CDP?.potentialId,
        patientReferralStatus: isSuccessPage ? 'New' : patientReferralStatus,
        journeyStatus: JOURNEY_STATUS.COMPLETED,
      };
      if (getCookie('shouldDeactivateExistingEnrollment') === 'true') {
        payload.deActivateExistingEnrollment = true;
      }
      //deleting the cookie once we have updated it
      const expireAfterTwoSecond = new Date();
      expireAfterTwoSecond.setTime(expireAfterTwoSecond.getTime() + 1);
      deleteCookie('shouldDeactivateExistingEnrollment', {
        expires: expireAfterTwoSecond,
        secure: true,
      });
      const { data: response } = await post(`/Patient/UpdatePatientOutcomeDetails`, payload);
      return response;
    }
  };

  const { mutate: updatePatientOutcomes } = useMutation(
    'update-patient-outcome-details',
    updatePatientOutcomeDetails,
    {
      onSuccess: () => undefined,
      onError: () => undefined,
    }
  );

  const [isLoaded, setIsLoaded] = useState(false);
  const router = useRouter();

  const resetCookies = () => {
    console.log(
      '------useUpdateCurrentJourney---outcome page',
      'resetCookies',
      'isAuthenticated',
      isAuthenticated
    );
    const enrollmentId = getCookie('enrollmentID');
    console.log(
      '------useUpdateCurrentJourney---outcome page',
      'resetCookies',
      'enrollmentId',
      enrollmentId
    );
    if (enrollmentId) {
      sessionStorage.setItem('enrollmentID_for_human_api', enrollmentId);
    }
    setCookie('journeyType', '', {
      expires: getCookieExpiryTime(0),
      secure: true,
    });
    setCookie('enrollmentID', null, {
      expires: getCookieExpiryTime(0),
      secure: true,
    });
    if (isAuthenticated) {
      return;
    }
    setCookie('bx_guest_ref', '', {
      expires: getCookieExpiryTime(0),
      secure: true,
    });
    const cookieName = 'bid_' + process.env.NEXT_PUBLIC_CDP_CLIENT_KEY;
    setCookie(cookieName, '', {
      secure: true,
      expires: getCookieExpiryTime(0),
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {
    const isOutcomePage = (route?.fields?.isOutcomePage as Field)?.value;
    if (isOutcomePage === true) {
      setCookie('journeyStatus', JOURNEY_STATUS.COMPLETED, {
        expires: getCookieExpiryTime(
          siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
        ),
        secure: true,
      });
      setCookie('journeyStep', '', {
        expires: getCookieExpiryTime(
          siteSettings?.resumeEnrollmentExpirationDays?.value || ENROLLMENT_EXPIRY_TIME_FALLBACK
        ),
        secure: true,
      });
      const enrollmentId = getCookie('enrollmentID');
      if (enrollmentId) {
        sessionStorage.setItem('enrollmentID_for_human_api', enrollmentId);
      }

      if (
        potentialParticipantDetailsFromStore?.potentialParticipant_ID &&
        !isJourneyStatusUpdated.current
      ) {
        const potentialParticipantId =
          potentialParticipantDetailsFromStore?.potentialParticipant_ID;
        const payload: any = {
          enrollmentId: getEnrollmentId(),
          journeyStep: '',
          journeyStatus: JOURNEY_STATUS.COMPLETED,
          isActiveEnrollment: '1',
          patientReferralStatus: router.asPath.includes('siteselectionsuccess')
            ? 'New'
            : cdpState?.patientReferralStatus,
        };
        if (getCookie('shouldDeactivateExistingEnrollment') === 'true') {
          payload.deActivateExistingEnrollment = true;
        }
        const guestType = 'customer';
        CdpService.updateCurrentJourneyInCDP(potentialParticipantId, guestType, payload);
        setTimeout(resetCookies, 5000);
        setIsLoaded(true);
        isJourneyStatusUpdated.current = true;
      }
    }
    if (isOutcomePage === true && !router.asPath.includes('siteselectionsuccess')) {
      updatePatientOutcomes(false);
    }
    if (isOutcomePage === true && router.asPath.includes('siteselectionsuccess')) {
      updatePatientOutcomes(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router?.query, cdpState]);

  return isLoaded;
};

export default useUpdateCurrentJourney;
